import type { TransitionComponentProps } from 'util/react-transition-component/types/transitionComponent.types';

export type PrimaryDropdownRef = HTMLElement;

export const textVariants = ['button-label-large', 'body-standard'] as const;

export const sizes = ['medium', 'large'] as const;
export type Size = (typeof sizes)[number];
export const defaultSize: Size = 'medium';

export type TextVariant = (typeof textVariants)[number];

export type PrimaryDropdownProps = {
  filters: Array<string>;
  filterLabels?: Record<string, string>;
  activeFilter?: string;
  onFilterClick: (filter: string, type: string) => void;
  disableTriggerInOnScroll?: boolean;
  type: string;
  textVariant?: TextVariant;
  size?: Size;
} & TransitionComponentProps;
